import { Components } from "@mui/material/styles";
import { Grey } from "@themes:palette";

export default {
  MuiSelect: {
    defaultProps: {
      size: "small",
    },
    styleOverrides: {
      root: {
        borderRadius: 7,
        fieldset: {
          borderWidth: 0,
        },
        "&:focus fieldset": {
          borderWidth: "1px",
        },

        "&.with-bg": {
          backgroundColor: Grey[50],
        },
      },
    },
  } as Components["MuiSelect"],
};
